import React, { useEffect } from 'react';
import './Footer.css';
import { initFacebookPixel } from '../facebookPixel';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { trackEvent } from '../facebookPixel';
const Footer = () => {
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  const handlePhoneClick = () => {
    // Track the event when the phone number is clicked
    trackEvent('InitiateCheckout');
  };

  return (
    <footer className="footer">
      <div className="footer-curve"></div>
      <div className="footer-container">
        <div className="footer-column footer-social">
          <h3 className="footer-heading">Follow Us</h3>
          <div className="footer-icons">
            <a href="https://www.instagram.com/machaxi/?hl=en" className="footer-icon" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://in.linkedin.com/company/machaxi" className="footer-icon" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://wa.me/+919663979929?text=Hello%20Machaxi" target="_blank" id="whatsapp-button" rel="noopener noreferrer" className="footer-icon">
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Contact Us</h3>
          <p className="footer-text">
            <a href="https://wa.me/+919663979929?text=Hello%20Machaxi" target="_blank" id="whatsapp-button" rel="noopener noreferrer" className="footer-text">
              Click here to Contact us on WhatsApp
            </a>
          </p>
          <p className="footer-text">Email: 
            <a href="mailto:hello@machaxi.com" className="footer-text"> hello@machaxi.com</a>
          </p>
          <p className="footer-text">
            Machaxi Helpline: 
            <a 
            id="call-button" 
              href="tel:+919355057527" 
              className="footer-text" 
              onClick={handlePhoneClick} // Track event when clicked
            >
              +91 9355057527
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
